var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 208.321,
    height: 338.732,
    viewBox: "0 0 208.321 338.732",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.232 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadows",
    transform: "translate(7.748 14.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M95.818,160.3c1.518-49.269-6.6-110.227-6.6-112.588,0-2.542.976-7.64,4.3-7.64,2.778,0,22.035,11.748,28.1,28.039",
    transform: "translate(-65.168 -40.07)",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M44.951,300.429c-6.428-20.538-23.118-69.456-24.483-71.512-1.684-2.532,1.042-6.748,5.06-6.748,2.3,0,17.788,5.251,24.511,14.95.243,6.23.8,41.51.8,41.51Z",
    transform: "translate(-19.961 -158.93)",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M142.618,249.62c-.962,5.181-34.381,75.613-53.766,64.3-1.195,4.428-1.615,6.987-1.615,6.987l-1.2,16.294-.649,20.715,1.9-6.873,3.66-10.481,2.591-5.414,4.272-5.209,11.978-10.554,14.676-11.248,7.88-5.838,2.032-10.113,3.313-15.86,3.16-17.4Z",
    transform: "translate(-62.668 -176.848)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M44.951,300.429c-6.428-20.538-23.118-69.456-24.483-71.512-1.684-2.532,1.042-6.748,5.06-6.748,2.3,0,17.788,5.251,24.511,14.95",
    transform: "translate(-13.463 -145.449)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M95.818,160.3c1.518-49.269-6.6-110.227-6.6-112.588,0-2.542.976-7.64,4.3-7.64,2.778,0,22.035,11.748,28.1,28.039",
    transform: "translate(-58.67 -26.589)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M85,196.282c.073-8.71,1.115-31.978,2.157-38.923S128.83,8.289,128.983,6.223s1.455-4.973,3.751-4.973c15.5,0,18.211,29.46,18.211,35.506,0,5.011-13.013,76.152-18.906,103.607",
    transform: "translate(-55.915 -1.25)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    d: "M102.308,552.987c-.347-7.64,13.2-50.7,14.933-58.343,0,0,41.326-34.381,47.925-40.284S206.84,385.6,206.84,383.167s-7.293-5.209-9.377-4.862C187.392,365.456,120.02,331.77,116.2,331.77s-55.217,33.686-73.276,51.745S20,484.226,19.656,490.477,8.543,524.858,5.07,534.929L1.25,552.987M129.049,436.3c-6.251,0-42.368-26.741-42.715-28.13S89.112,391.5,90.5,390.113s31.255-22.573,32.992-22.573,41.326,19.795,55.565,16.669C164.471,391.155,135.3,436.3,129.049,436.3Z",
    transform: "translate(-1.25 -216.987)",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    d: "M509.33,472.146c1.736-.542,16.482-4.834,19.767-6.376",
    transform: "translate(-332.884 -304.452)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg06);
export default __webpack_public_path__ + "static/media/06.c042a7b8287a9c3323dad251f2012497.svg";
export { ForwardRef as ReactComponent };